"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMutationObserver = void 0;

var _react = require("react");

var _excluded = ["onMutate", "options"];

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/**
 * Accepts a ref and calls the `onMutate` callback when mutations are observed.
 */


var useMutationObserver = function useMutationObserver(_ref) {
  var onMutate = _ref.onMutate,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
  } : _ref$options,
      rest = _objectWithoutProperties(_ref, _excluded);

  (0, _react.useEffect)(function () {
    if (typeof MutationObserver === "undefined") {
      return;
    }

    var el = "ref" in rest ? rest.ref.current : rest.element;

    if (el) {
      var observer = new MutationObserver(onMutate); // Start observing the target node for configured mutations

      observer.observe(el, options);
      return function () {
        observer.disconnect();
      };
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [onMutate, options]);
};

exports.useMutationObserver = useMutationObserver;